import {RenderAlert} from "components/src/common/RenderAlert.tsx";
import {Dispatch, SetStateAction} from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import {Placement} from "react-bootstrap/esm/types";

interface PageAlertProps {
    message : string | undefined
    setMessage?: Dispatch<SetStateAction<string | undefined>>
    variant? : "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark"
    tooltipPlacement?: Placement
    scrollIntoView?: boolean
}

export const PageAlert = ({message, setMessage, variant = "danger", tooltipPlacement = "bottom", scrollIntoView = true}: PageAlertProps) => {
    return (
        <Row className="px-4">
            <Col>
                <RenderAlert message={message}
                             setMessage={setMessage}
                             variant={variant}
                             tooltipPlacement={tooltipPlacement}
                             scrollIntoView={scrollIntoView}/>
            </Col>
        </Row>
    );
};
